import React, { useState } from 'react';
import uploadDocumentIcon from "../../assets/upload-documents-icon.png";
import closeIcon from "../../assets/close-icon.png";

function UploadMotivationLetter({ setActiveIndicator, mLetterfile, setMLetterFile, uploadProgress, setUploadProgress, uploadComplete, setUploadComplete, uploading, setUploading, isDragging, setIsDragging }) {
  let uploadInterval;

  const HandleNext = () => {
    setActiveIndicator(3);
  };

  const HandleBack = () => {
    setActiveIndicator(1);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setMLetterFile(selectedFile);
      startUpload();
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      setMLetterFile(droppedFile);
      startUpload();
    }
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const startUpload = () => {
    setUploadProgress(0);
    setUploadComplete(false);
    setUploading(true);
    uploadInterval = setInterval(() => {
      setUploadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(uploadInterval);
          setUploadComplete(true);
          setUploading(false);
          return 100;
        }
        return prev + 20;
      });
    }, 250);
  };

  const cancelUpload = () => {
    clearInterval(uploadInterval);
    setUploadProgress(0);
    setUploading(false);
    setMLetterFile(null);
    setUploadComplete(false);
  };

  return (
    <div>
      <div className=' mb-4'>
      <h1 className="text-5xl font-bold mb-4">Upload Motivational Letter</h1>
      <p>Add a file to complete your dataset upload.</p>
      </div>
      <div
        className={`border-dashed border-2 border-gray-400 p-8 mb-4 rounded-md ${isDragging ? 'bg-secondary' : 'bg-white'}`}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      >
      
        
        <input type="file" onChange={handleFileChange} className="hidden" />
        <button
          onClick={() => document.querySelector('input[type="file"]').click()}
          className="mt-2 py-4 px-6 rounded-md bg-primary flex gap-4 items-center m-auto"
        >
        <img src={uploadDocumentIcon} className='h-6 brightness-0 invert' />
          <p className='text-xl font-bold text-white'>Select File</p>
        </button>
        <p className='mt-4 opacity-50'>or</p>
        <p className='mt-4'>Drag & Drop your file here</p>
      </div>
      {mLetterfile && (
        <div className='p-6 border rounded-md'>
      <div className='flex gap-4 items-center justify-between mb-4'>
      {mLetterfile && <p className='text-xl font-bold text-left'>{` ${!uploadComplete ? `Uploading ${mLetterfile?.name} ...` : 'Upload Complete!'} `}</p>}
      {uploading && (
        <img src={closeIcon} onClick={cancelUpload} className='h-4' />
      )}
      </div>
      <div className='flex gap-2 items-center'>
      <div className="relative w-full h-2 bg-gray-200">
        <div
          className="absolute h-full bg-default"
          style={{ width: `${uploadProgress}%` }}
        />
      </div>
      <span>{uploadProgress}%</span>
      </div>
      
      </div>
      )}
      {uploadComplete && (
        <div className="flex gap-2 mt-4 justify-end">
        <button
          className="py-2 px-4 rounded-md border"
          onClick={HandleBack}
        >
          Back
        </button>
        <button
          className="py-2 px-4 rounded-md bg-default text-white border"
          onClick={HandleNext}
        >
          Next
        </button>
      </div>
      )}
    </div>
  );
}

export default UploadMotivationLetter;